<template>
    <button @click="$emit('click')"><span class="text-2xl text-ultramarine" :class="iconClass"></span></button>
</template>

<script>
    export default {
        name: "HMSurveyButton",
        props: ['state'],
        computed: {
            iconClass() {
                return 'icon-' + this.state;
            }
        },
    }
</script>

<style scoped>

</style>